// Block I (UI-16): how a person is drawn on the Team pages.
//
// Avatars are a pastel with ink initials, chosen from the person's id so it is stable. They used
// to be filled with the user's own colour (often a dark one) or the old default brand blue, with
// white text: decision 16 (no brand colour in the app's own interface) and the contrast rule.

const TINTS = ['pastel-blue', 'pastel-lilac', 'pastel-mint', 'pastel-yellow', 'pastel-pink', 'pastel-peach', 'pastel-periwinkle', 'pastel-green'];

export function personTint(id) {
  const s = String(id ?? '');
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return TINTS[h % TINTS.length];
}

// Decision 35: 'user' is a member and 'backup_owner' an admin. The word a person is shown as.
export function roleLabel(role) {
  const r = String(role || '').toLowerCase();
  if (r === 'owner') return 'Owner';
  if (r === 'admin' || r === 'backup_owner' || r === 'super_admin') return 'Admin';
  if (r === 'finance') return 'Finance';
  return 'Member';
}

// The role as the forms hold it: member, finance or admin.
export function formRole(role) {
  const r = String(role || '').toLowerCase();
  if (r === 'admin' || r === 'backup_owner' || r === 'super_admin' || r === 'owner') return 'admin';
  if (r === 'finance') return 'finance';
  return 'member';
}

// Who counts as an admin for "the last admin" (the server's own rule, routes/team.js: the owner
// or an admin role).
export const isAdminRole = (role) => ['owner', 'admin', 'super_admin'].includes(String(role || '').toLowerCase());

export const firstName = (name) => String(name || '').trim().split(/\s+/)[0] || 'Someone';
